export const useLocation = (): Omit<
    Location,
    "ancestorOrigins" | "assign" | "reload" | "replace"
> => {
    const {
        location: { href, origin, protocol, host, hostname, port, pathname, search, hash },
    } = window;
    return { href, origin, protocol, host, hostname, port, pathname, search, hash };
};
